import _ from 'lodash'
import React from 'react'
import { buildClassName } from '@vero/ui-core-browser/utils.js'
import useEnv from '@vero/ui-core-browser/hooks/env.js'
import useActiveCompany from '@vero/ui-core-browser/hooks/active-company.js'
import IconX from '@vero/ui-components/icons/x.jsx'
import IconExternalLink from '@vero/ui-components/icons/external-link.jsx'

export default function ({ company, className, card = false }) {
  const { env } = useEnv()
  const { activeCompany, storeActiveCompany, resetActiveCompany } = useActiveCompany()

  const resolvedCompany = company || activeCompany
  const active = resolvedCompany?.slug === activeCompany?.slug

  if (card) {
    const envDomain = env === 'prod' ? '' : `.${env}`

    return (
      <div
        className={buildClassName([
          'card card-side border-b md:card-bordered',
          resolvedCompany?.active ? 'bg-base-100 cursor-pointer md:hover:border-secondary' : 'bg-neutral-100',
          active && 'md:border-secondary shadow-inner md:shadow-none',
          'md:drop-shadow-sm pl-4',
          className
        ])}
        onClick={resolvedCompany?.active ? () => storeActiveCompany(resolvedCompany) : null}
      >
        {resolvedCompany?.logo && (
          <figure className='max-w-12 md:max-w-16'>
            <img
              src={resolvedCompany?.logo}
              alt='logo'
            />
          </figure>
        )}

        <div className='card-body block'>
          <h2 className='card-title text-2xl font-light'>{resolvedCompany?.name || _.startCase(resolvedCompany?.slug)}</h2>

          {env === 'dev' && <span className='text-sm font-light text-neutral-600'>{resolvedCompany?.slug}</span>}
          {env !== 'dev' && (
            <a
              href={`https://${resolvedCompany?.slug}${envDomain}.manager.vero.lease`}
              className='link link-hover text-sm font-light text-neutral-600'
              target='_blank'
              rel='noreferrer'
              onClick={e => {
                e.stopPropagation()
              }}
            >
              <span className='align-middle'>{resolvedCompany?.slug}</span>
              <IconExternalLink className='w-4 inline align-middle ml-1' />
            </a>
          )}
        </div>

        {active && (
          <div
            className='p-2'
            onClick={e => {
              e.stopPropagation()
              resetActiveCompany()
            }}
          >
            <IconX className='w-8 h-8 hover:stroke-primary cursor-pointer' />
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={buildClassName(['flex items-center gap-2', className])}>
      <h1 className='hidden md:block text-xl font-light'>{resolvedCompany?.name || resolvedCompany?.slug}</h1>

      {resolvedCompany?.logo && (
        <img
          className='max-w-6 md:max-w-8'
          src={resolvedCompany?.logo}
          alt='logo'
        />
      )}
    </div>
  )
}
